{
  "name": "sharelock",
  "version": "0.0.0",
  "scripts": {
    "ng": "ng",
    "mock:server": "nodemon server/server.js --ext js,ts,json,html",
    "start:local": "ng serve --configuration=local-dev",
    "start:dev": "ng serve --configuration=dev",
    "start-clean:dev": "npx ng cache clean && ng serve --configuration=dev",
    "start:uat": "ng serve --configuration=uat",
    "start:prod": "ng serve --configuration=prod",
    "start:mock": "nodemon server/server.js --ext js,ts,json,html & ng serve --configuration=mock",
    "install:ci": "npm i & npm install -D tailwindcss",
    "build:dev": "ng build --configuration=dev",
    "build:uat": "ng build --configuration=uat",
    "build:prod": "ng build --configuration=prod",
    "watch": "ng build --watch --configuration=local-dev",
    "test": "ng test --watch=false --browsers Chrome",
    "test:ci": "ng test --watch=false --browsers ChromiumNoSandbox",
    "serve:ssr:sharelock": "node dist/sharelock/server/server.mjs",
    "lint": "npx eslint \"src/**/*.{js,jsx,ts,tsx,html}\" --quiet --fix",
    "format": "npx prettier \"src/**/*.{js,jsx,ts,tsx,html,css,scss}\" --write",
    "prepare": "husky",
    "updates:check": "npx npm-check-updates",
    "updates:interactive": "npx npm-check-updates -i"
  },
  "private": true,
  "dependencies": {
    "@angular/animations": "^21.2.9",
    "@angular/cdk": "^21.2.7",
    "@angular/common": "^21.2.9",
    "@angular/compiler": "^21.2.9",
    "@angular/core": "^21.2.9",
    "@angular/forms": "^21.2.9",
    "@angular/material": "^21.2.7",
    "@angular/material-moment-adapter": "^21.2.7",
    "@angular/platform-browser": "^21.2.9",
    "@angular/platform-browser-dynamic": "^21.2.9",
    "@angular/platform-server": "^21.2.9",
    "@angular/router": "^21.2.9",
    "@angular/ssr": "^21.2.7",
    "@cospired/i18n-iso-languages": "^4.2.0",
    "@ngx-translate/core": "^17.0.0",
    "@ngx-translate/http-loader": "^17.0.0",
    "@tailwindcss/postcss": "^4.2.1",
    "express": "^5.2.1",
    "file-saver": "^2.0.5",
    "i18n-iso-countries": "^7.14.0",
    "json-server": "^0.17.4",
    "jszip": "^3.10.1",
    "ngx-mask": "^21.0.1",
    "ngx-quill": "^30.0.1",
    "ngx-translate-multi-http-loader": "^20.0.0",
    "npm-check-updates": "^19.6.3",
    "quill": "^2.0.3",
    "rxjs": "~7.8.2",
    "swiper": "^12.1.2",
    "tslib": "^2.8.1",
    "uuid": "^13.0.0",
    "zone.js": "~0.16.1"
  },
  "devDependencies": {
    "@angular-eslint/builder": "^21.2.0",
    "@angular-eslint/eslint-plugin": "^21.2.0",
    "@angular-eslint/eslint-plugin-template": "^21.2.0",
    "@angular-eslint/schematics": "^21.2.0",
    "@angular-eslint/template-parser": "^21.2.0",
    "@angular/build": "^21.2.7",
    "@angular/cli": "^21.2.7",
    "@angular/compiler-cli": "^21.2.9",
    "@eslint/eslintrc": "^3.3.4",
    "@eslint/js": "^9.39.3",
    "@types/express": "^5.0.6",
    "@types/file-saver": "^2.0.7",
    "@types/jasmine": "~6.0.0",
    "@types/node": "^25.3.3",
    "@types/uuid": "^11.0.0",
    "@typescript-eslint/eslint-plugin": "^8.56.1",
    "@typescript-eslint/parser": "^8.56.1",
    "autoprefixer": "^10.4.27",
    "eslint": "^9.25.0",
    "eslint-config-prettier": "^10.1.8",
    "eslint-plugin-prettier": "^5.5.5",
    "husky": "^9.1.7",
    "jasmine-core": "^6.1.0",
    "karma": "~6.4.4",
    "karma-chrome-launcher": "~3.2.0",
    "karma-coverage": "~2.2.1",
    "karma-jasmine": "~5.1.0",
    "karma-jasmine-html-reporter": "~2.2.0",
    "lint-staged": "^16.3.1",
    "nodemon": "^3.1.14",
    "postcss": "^8.5.8",
    "prettier": "^3.8.1",
    "prettier-plugin-tailwindcss": "^0.7.2",
    "tailwindcss": "^4.2.1",
    "typescript": "^5.9.3"
  }
}
